import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { mockMutualFunds } from '../../utils/mockMutualFunds';
import styles from './MutualFundInvestPage.module.css';
import Keypad from '../../components/Keypad';

const MutualFundInvestPage = ({ openDepositModal }) => {
  const { id } = useParams();
  const fund = mockMutualFunds.find(f => f.id === parseInt(id));

  const [amount, setAmount] = useState('10000');
  const [error, setError] = useState('');

  const getInitials = (name) => (name ? name.charAt(0).toUpperCase() : '');

  const handleInput = (key) => {
    setAmount(prev => prev + key);
  };

  const handleBackspace = () => {
    setAmount(prev => prev.slice(0, -1));
  };

  const handleQuickAdd = (value) => {
    setAmount(prev => (parseInt(prev || 0) + value).toString());
  };

  useEffect(() => {
    const value = parseInt(amount);
    if (value < 10000) {
      setError('Minimum investment is \u20B910,000');
    } else if (value % 1000 !== 0) {
      setError('Investment must be in multiples of \u20B91,000');
    } else {
      setError('');
    }
  }, [amount]);

  const handleInvestNow = () => {
    if (!error) {
      openDepositModal({ amount: amount });
    }
  };

  if (!fund) {
    return <div>Fund not found</div>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles['fund-initials']}>{getInitials(fund.name)}</div>
        <div>
          <h1 className={styles.fundName}>{fund.name}</h1>
          <p className={styles.fundCategory}>{fund.category}</p>
        </div>
      </div>

      <div className={styles.investmentType}>
        One-Time Investment
      </div>

      <div className={styles.amountDisplay}>
        <span className={styles.currencySymbol}>₹</span>
        <span className={styles.amountValue}>{amount || '0'}</span>
      </div>
      {error && <p className={styles.error}>{error}</p>}

      <Keypad
        onInput={handleInput}
        onBackspace={handleBackspace}
        onQuickAdd={handleQuickAdd}
      />

      <div className={styles.bottomContainer}>
        <button className={styles.investButton} onClick={handleInvestNow} disabled={!!error}>
          Invest Now
        </button>
      </div>
    </div>
  );
};

export default MutualFundInvestPage;
